import { Locale } from '@ps-smart-cp/ppfw-client';

const automaticReLeaseConfig = {
  automaticReLease: new Map([
    [Locale.ja, '自動再リースする'],
    [Locale.en, 'Re-lease Automatically'],
  ]),

  doNotAutomaticReLease: new Map([
    [Locale.ja, '自動再リースしない'],
    [Locale.en, 'Do Not Re-lease Automatically'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { automaticReLeaseConfig };
